export const FLOATING_THEME_MENU_ITEM_SIZE = 52;
export const FLOATING_THEME_CUSTOMIZE_BUTTON_WIDTH = 74;
